import {Sprite} from '@pixi/react';
import {Assets} from 'pixi.js';
import {Scene} from './Scene';
import {GAME_BACKGROUND, OVERLAY} from '../assetManifest';
import {FullBodyAvatar} from '../pixijs/FullBodyAvatar';
import {useDraftAvatar} from '../state/uiStore';

export function Lobby() {
    const avatar = useDraftAvatar();

    return (
        <Scene>
            <Sprite texture={Assets.get(GAME_BACKGROUND)}/>
            <Sprite texture={Assets.get(OVERLAY)}/>
            <FullBodyAvatar avatar={avatar} position={{x: 1140, y:500}} scale={1.8}/>
        </Scene>
    );
}
